import React from 'react';
import { translate } from 'react-i18next';

import DashboardButtons from 'components/dashboard/DashboardButtons';
import AssetStatusSummary from 'components/dashboard/AssetStatusSummary';
import ChartAccountsTotal from 'components/dashboard/ChartAccountsTotal';
import ChartCostCentersTotal from 'components/dashboard/ChartCostCentersTotal';
import ChartStatusTotal from 'components/dashboard/ChartStatusTotal';
import ChartCostCentersAmount from 'components/dashboard/ChartCostCentersAmount';
import * as Common from 'common/components';

const DashboardView = ({ t, company, subcompany, dashboard }) => {
  return (
    <Common.Wrapper fluid={true}>
      <DashboardButtons company={company} subcompany={subcompany} />
      <AssetStatusSummary summary={dashboard.assetsSummary || dashboard.assetStatusSummary} showTotal={true}/>
      <ChartAccountsTotal data={dashboard.totalByAccount} />
      <ChartCostCentersTotal data={dashboard.totalByCostCenter} />
      <ChartStatusTotal data={dashboard.totalByStatus} />
      <ChartCostCentersAmount data={dashboard.amountByCostCenter} />
    </Common.Wrapper>
  );
};

export default translate()(DashboardView);



// WEBPACK FOOTER //
// src/components/dashboard/DashboardView.js